import React, { createContext, useContext, useState, useEffect } from "react";
import instance from "../Interceptor/api_instance";
import i18next from "i18next";

const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  const [pfp, setPfp] = useState(localStorage.getItem("pfp_url"));
  const [isSideOpen, setIsSideOpen] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [yardsData, setYardsData] = useState(localStorage.getItem("yardsData") ? JSON.parse(localStorage.getItem("yardsData")) : []);

  useEffect(() => {
    if (!user) {
      return;
    }
    const fetchYardsData = async () => {
      const cached = localStorage.getItem("yardsData");
      if (cached) {
        setYardsData(JSON.parse(cached));
      } else {
        const response = await instance.get("assets/locations?location_type=Agramont%20Yard");
        if (response.status === 200) {
          setYardsData(response.data);
          localStorage.setItem("yardsData", JSON.stringify(response.data));
        }
      }
    };
    fetchYardsData();
  }, [user]);

  useEffect(() => {
    if (!user) {
      return;
    }
    const fetchData = async () => {
      const cached = localStorage.getItem("customers");
      if (cached) {
        setCustomers(JSON.parse(cached));
      } else {
        const response = await instance.get("assets/customers");
        if (response.status === 200) {
          setCustomers(response.data);
          localStorage.setItem("customers", JSON.stringify(response.data));
        }
      }
    };
    fetchData();
    if (user && user.user_language) {
      localStorage.setItem("language", user.user_language);
      i18next.changeLanguage(user.user_language);
    }
  }, [user]);

  const login = (userData) => {
    setUser(userData);
    const profilePic = userData.profile_pic || null;
    setPfp(profilePic);
    localStorage.setItem("pfp_url", userData.profile_pic);
    localStorage.setItem("user", JSON.stringify(userData));
    i18next.changeLanguage(userData.user_language);
  };

  const updateSettings = (settings) => {
    // apply settings atomically based on previous user state
    setUser((prevUser) => {
      const updatedUser = { ...(prevUser || {}), ...settings };
      // persist updated user immediately
      localStorage.setItem("user", JSON.stringify(updatedUser));
      return updatedUser;
    });

    // persist language and update i18n immediately so UI updates without refresh
    if (settings.user_language) {
      localStorage.setItem("language", settings.user_language);
      i18next.changeLanguage(settings.user_language);
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("pfp_url");
  };

  const updateUser = (user) => {
    setUser((prevUser) => ({ ...prevUser, ...user }));
  };

  const openSideBar = () => {
    setIsSideOpen(!isSideOpen);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        updateUser,
        updateSettings,
        pfp,
        setPfp,
        login,
        logout,
        isSideOpen,
        openSideBar,
        customers,
        yardsData,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
